import * as React from 'react';
import {ChangeEvent} from "react";

class LoginForm extends React.Component<any, any> {

    handleSubmit = () => {
        let {username, password} = this.props;
        this.props.onSubmit({username, password});
    }
    handleChangeUsername = (event: ChangeEvent<HTMLInputElement>) => {
        this.props.onChangeValues({username:event.target.value, password: this.props.password});
    }
    handleChangePassword = (event: ChangeEvent<HTMLInputElement>) => {
        this.props.onChangeValues({username:this.props.username, password: event.target.value});
    }
    render() {
        let { username, password, error, loading } = this.props;
        return (
            <div className="login-form">
                <div>
                    <label htmlFor="username">Username:</label>
                    <input className="form-control"
                           type="text"
                           name="username"
                           id="username"
                           value={username}
                           onChange={this.handleChangeUsername}/>
                </div>
                <br/>
                <div>
                    <label htmlFor="password">Password:</label>
                    <input className="form-control"
                           type="password"
                           name="password"
                           value={password}
                           onChange={this.handleChangePassword}/>
                    {/*{username && password !== 'password' ? <i style={{position: 'relative', bottom: '1.8em', marginLeft: '5em', height: 0}} className="fa fa-arrow-left bounce-horizontal">Enter '<b>password</b>' here</i> : null}*/}
                </div>
                {error ? <div className="well error">{error}</div> : null}
                <hr/>
                <div>
                    <button className="btn btn-primary"
                            type="button"
                            disabled={loading}
                            onClick={this.handleSubmit}>
                        {loading ? <i className="fa fa-spin fa-spinner"/> : null} <span>Log in</span>
                    </button>
                    {/*{username && password === 'password' ? <i style={{position: 'relative'}} className="fa fa-arrow-left bounce-horizontal"> Click Me!</i> : null}*/}
                </div>
            </div>
        );
    }
}

export default LoginForm;
